import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useI18n } from '../../context/I18nContext';
import VzdEndpointList from './VzdEndpointList';
import './VzdSearchResults.css';

const VzdSearchResults = ({ results, type, onSelectUser, selectedUserIds }) => {
  const { t } = useI18n();
  const [expandedId, setExpandedId] = useState(null);

  const handleToggleExpand = useCallback((id) => {
    setExpandedId(prev => prev === id ? null : id);
  }, []);

  if (!results || results.length === 0) {
    return (
      <div className="vzd-no-results">
        <ion-icon name="search-outline" />
        <span>{t('VzdSearch.noResults')}</span>
      </div>
    );
  }

  return (
    <div className="vzd-results-list">
      {results.map((result) => (
        <div key={result.id} className="vzd-result-item">
          <div
            className="vzd-result-header"
            onClick={() => handleToggleExpand(result.id)}
          >
            <div className="vzd-result-info">
              <div className="vzd-result-name">
                {type === 'person' ? result.practitionerName : result.serviceName}
              </div>
              {type === 'person' && result.qualifications?.length > 0 && (
                <div className="vzd-result-qualifications">
                  {result.qualifications.map((q, i) => (
                    <span key={i} className="vzd-qualification-badge">{q}</span>
                  ))}
                </div>
              )}
              {type === 'healthcareService' && result.organizationName && (
                <div className="vzd-result-org">{result.organizationName}</div>
              )}
            </div>
            <div className="vzd-result-meta">
              <span className="vzd-endpoint-count">
                {t('VzdSearch.endpointsCount', { count: result.endpoints?.length || 0 })}
              </span>
              <ion-icon name={expandedId === result.id ? 'chevron-up-outline' : 'chevron-down-outline'} />
            </div>
          </div>
          {expandedId === result.id && (
            <VzdEndpointList
              endpoints={result.endpoints}
              onSelectUser={onSelectUser}
              displayName={type === 'person' ? result.practitionerName : result.serviceName}
              selectedUserIds={selectedUserIds}
            />
          )}
        </div>
      ))}
    </div>
  );
};

VzdSearchResults.propTypes = {
  results: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  onSelectUser: PropTypes.func.isRequired,
  selectedUserIds: PropTypes.instanceOf(Set),
};

export default VzdSearchResults;
